export default "__VITE_ASSET__BjXdJudJ__"